import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'

const base = ''
const routes = [
  {
    path: base + '/',
    name: 'Home',
    component: Home,
    redirect: base + '/sys/index',
    children: [
      // { path: '/home', redirect: '/' },
      { path: base + '/sys/index', name: 'index', meta: { keepAlive: true }, component: () => import('@/views/sys/index.vue') },
      { path: base + '/sys/config', name: 'config', meta: { keepAlive: true }, component: () => import('@/views/sys/config.vue') },
      { path: base + '/sys/module', name: 'module', meta: { keepAlive: true }, component: () => import('@/views/sys/module.vue') },
      { path: base + '/sys/depa', name: 'depa', meta: { keepAlive: true }, component: () => import('@/views/sys/depa.vue') },
      { path: base + '/sys/admin', name: 'admin', meta: { keepAlive: true }, component: () => import('@/views/sys/admin.vue') },
      { path: base + '/sys/role', name: 'role', meta: { keepAlive: true }, component: () => import('@/views/sys/role.vue') },
      { path: base + '/sys/log', name: 'log', meta: { keepAlive: true }, component: () => import('@/views/sys/log.vue') },
      { path: base + '/data/dictionary', name: 'dictionary', meta: { keepAlive: true }, component: () => import('@/views/data/dictionary.vue') },
      { path: base + '/data/businessConfig', name: 'businessConfig', meta: { keepAlive: true }, component: () => import('@/views/data/businessConfig.vue') },
      { path: base + '/data/news', name: 'news', meta: { keepAlive: true }, component: () => import('@/views/data/news.vue') },
      { path: base + '/bus/yard', name: 'yard', meta: { keepAlive: true }, component: () => import('@/views/bus/yard.vue') },
      { path: base + '/bus/yardblacklist', name: 'yardblacklist', meta: { keepAlive: true }, component: () => import('@/views/bus/yardblacklist.vue') },
      { path: base + '/bus/vehicle', name: 'vehicle', meta: { keepAlive: true }, component: () => import('@/views/bus/vehicle.vue') },
      { path: base + '/bus/reserve', name: 'reserve', meta: { keepAlive: true }, component: () => import('@/views/bus/reserve.vue') },
      { path: base + '/bus/execflow', name: 'execflow', meta: { keepAlive: true }, component: () => import('@/views/bus/execflow.vue') }
      // { path: base + '/info/editor', name: 'editor', meta: { keepAlive: true }, component: () => import('@/views/info/editor.vue') }
      // { path: base + '/info/newsadd:sid', name: 'newsadd', meta: { keepAlive: true }, component: () => import('@/components/info/newsadd.vue') },
      // { path: base + '/info/news:sid', name: 'news', meta: { keepAlive: true }, component: () => import('@/components/info/news.vue') },
    ]
  },
  {
    path: base + '/login',
    name: 'login',
    component: () => import('@/views/login')
  }
  // {
  //   path: base + '/news1',
  //   name: 'news1',
  //   component: () => import('@/views/data/news1.vue')
  // }
  // {
  //   path: '/index',
  //   name: 'Index',
  //   component: () => import('@/views/index.vue')
  // }
]
const router = createRouter({
  // 去掉#号
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHistory(),
  // history: createWebHashHistory(),
  // 记录页面滚动位置
  // scrollBehavior (to, from, savedPosition) {
  //   if (savedPosition) { // 如果savedPosition存在，滚动条会自动跳到记录的值的地方
  //     return savedPosition
  //   } else {
  //     return { x: 0, y: 0 } // savedPosition也是一个记录x轴和y轴位置的对象
  //   }
  // },
  routes
})

export default router
